var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M10.658 12.158V11H8.342v4.342H4v2.316h4.342V22h2.316v-4.342H15v-2.316h-4.342v-3.184Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28 23.1V26H17.633v-2.9H21.4V8.28c-.147.235-.394.498-.742.791-.361.296-.738.57-1.128.82-.422.254-.864.47-1.32.645a3.292 3.292 0 0 1-1.21.263V7.812c.495 0 .99-.137 1.485-.41.513-.274.99-.586 1.43-.938a9.85 9.85 0 0 0 1.045-.995L21.4 5h3.108v18.1H28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOne);
export default __webpack_public_path__ + "static/media/plus-one.5916a408d4fb6b9b93e61aec519e61e1.svg";
export { ForwardRef as ReactComponent };